// The migration suffix belongs to the workspace chrome, not the legal name.
// Keep the stored cabinet identity unchanged in forms and business documents.
export function cabinetDisplayName(cabinet) {
  return (cabinet?.nom || "Cabinet").replace(/ · France$/, "");
}
